export const DOMAIN_ORDER = [
  "FM", "GOV", "FIN", "BNK", "LLC", "COV", "MEM", "AST", "TAX", "REC", "RSK", "FMT",
] as const;

export const DOMAIN_LABELS: Record<string, string> = {
  FM: "Front Matter",
  GOV: "Governance",
  FIN: "Finance",
  BNK: "Banking",
  LLC: "The Entity Structure",
  COV: "The Religious Covenant",
  MEM: "Membership",
  AST: "Assets",
  TAX: "Tax",
  REC: "Records Program",
  RSK: "Risk Response",
  FMT: "Sample Formats",
};

export const DOC_ID_PATTERN = /\b([A-Z]{3}-\d{3})\b/g;

export function splitTriggerTags(tags: string | null | undefined): string[] {
  if (!tags) return [];
  return tags
    .split(";")
    .map((t) => t.trim())
    .filter(Boolean);
}
